import { Modal } from "@/components/modal/Modal";
import { useTranslate } from "@/hooks/use-translate/useTranslate";
import PrimaryButton from "@/components/buttons/primary-button/PrimaryButton";
import SecondaryButton from "@/components/buttons/secondary-button/SecondaryButton";
import Title from "@/components/modal/Title";
import type { ActiveInspectionRegister } from "../inspections-lists/InspectionsLists.d";
import { useDevice } from "@/store/useDevice";
import { ModalMobile } from "@/components/modal/mobile/ModalMobile";
import IconButton from "@/components/buttons/IconButton";

const ModalRemoveInspection = ({
  inspection,
  removeInspection,
  closeModal,
}: {
  inspection: ActiveInspectionRegister;
  removeInspection: (id: number) => void;
  closeModal: () => void;
}) => {
  const translate = useTranslate();

  const { isMobile } = useDevice();

  if (isMobile) {
    return (
      <ModalMobile>
        <ModalMobile.Header className="border-b">
          <div className="flex justify-between items-center bg-white">
            <h1 className="text-lg">
              {translate("removeInspection", [inspection.snStand])}
            </h1>
            <IconButton
              iconClassName="size-6"
              className="bg-transparent text-ib-red-main"
              icon="close"
              onClick={closeModal}
            />
          </div>
        </ModalMobile.Header>
        <ModalMobile.Content className="bg-[#FAFAFA]">
          <div className="flex flex-col gap-4 px-3 py-4">
            <p className="text-ib-gray-main text-lg">
              {translate("removeInspectionDescription", [inspection.snStand])}
            </p>
          </div>
        </ModalMobile.Content>
        <ModalMobile.Footer className="bg-white border-t">
          <div className="w-full flex flex-col gap-4 ">
            <PrimaryButton
              colour="red"
              icon="check"
              label={translate("remove")}
              onClick={() => removeInspection(inspection.id)}
            />
            <SecondaryButton
              colour="red"
              label={translate("cancel")}
              onClick={closeModal}
            />
          </div>
        </ModalMobile.Footer>
      </ModalMobile>
    );
  }

  return (
    <Modal>
      <Modal.Header>
        <Title title={translate("removeInspection")} />
      </Modal.Header>
      <Modal.Content>
        <div className="flex flex-col space-y-6">
          <p>
            {translate("removeInspectionDescription", [inspection.snStand])}
          </p>
        </div>
      </Modal.Content>
      <Modal.Footer>
        <div className="w-full flex justify-between">
          <div>
            <SecondaryButton
              onClick={closeModal}
              label={translate("cancel")}
              colour={"red"}
            />
          </div>
          <div>
            <PrimaryButton
              onClick={() => removeInspection(inspection.id)}
              label={translate("remove")}
              colour={"red"}
            />
          </div>
        </div>
      </Modal.Footer>
    </Modal>
  );
};

export default ModalRemoveInspection;
